import * as React from 'react'

import { SVGResponsive } from 'main/ui'

export function Verified() {
  return (
    <SVGResponsive height={24} width={24}>
      <path
        d="M5.5 3C5.5 2.72386 5.72386 2.5 6 2.5H18C18.2761 2.5 18.5 2.72386 18.5 3V17.0059C18.5 17.1771 18.4125 17.3363 18.268 17.428L12.268 21.2376C12.1044 21.3414 11.8956 21.3414 11.732 21.2376L5.732 17.428C5.58752 17.3363 5.5 17.1771 5.5 17.0059V3Z"
        fill="white"
        stroke="currentColor"
      />
      <rect
        x="9"
        y="13.3999"
        width="7.63675"
        height="0.848528"
        transform="rotate(-45 9 13.3999)"
        fill="currentColor"
      />
      <rect
        x="9.59998"
        y="8"
        width="7.63675"
        height="0.848528"
        transform="rotate(45 9.59998 8)"
        fill="currentColor"
      />
    </SVGResponsive>
  )
}

export default React.memo(Verified)
